import { z } from 'src/lib'
import { DetalleFields, DetallePutFields } from './detalle-fields'
import { BaseResponse } from 'src/types'
import { getEndpoint } from '.'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z.object({
    [DetalleFields.IdOperacion]: z.number(),
    [DetallePutFields.CodOperacionTipo]: z.number(),
    [DetallePutFields.Excepcion]: z.string()

    //[DetallePutFields.CodOperacionExcepcion]: z.number(),
})

// const schema = z.array(updateDTO)

export type OperacionWRCDetalleUpdateDTO = z.infer<typeof schema>

// export type ListOperacionWRCDetalleUpdateDTO = z.infer<typeof schema>

export const postDetalle = (detalleUpdate: OperacionWRCDetalleUpdateDTO): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${detalleUpdate[DetalleFields.IdOperacion]}/detalles`)

    const parsed = schema.safeParse(detalleUpdate)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(endpoint, parsed.data)
        .then(response => {
            // TODO: habría que parsear tambien la respuesta
            // en el hook generico?
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
